import InteractiveButton from '../../InteractiveButton/InteractiveButton';

export interface TableStateProps {
  disablePrev: boolean;
  disableNext: boolean;
  active: boolean;
  finished: boolean;
  onPressPrev: () => any;
  onPressNext: () => any;

  currText?: string;
}

export const TableState = ({
  active,
  disablePrev,
  disableNext,
  finished,
  onPressNext,
  onPressPrev,
  currText,
}: TableStateProps) => {
  if (!active && !finished) {
    return null;
  }

  if (finished) {
    return (
      <div className="flex w-full items-center justify-center">
        <p className={'inline-flex bg-success bg-opacity-10 px-3 py-1 text-sm font-medium text-success'}>Done</p>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center">
      <InteractiveButton onClick={onPressPrev} disabled={disablePrev} className="mx-5 w-full max-w-[110px]">
        Previous Step
      </InteractiveButton>

      <div className='w-[135px]'>
        <p className={'inline-flex bg-strokedark bg-opacity-10 px-3 py-1 text-sm font-medium text-strokedark'}>
          {currText ? currText : 'Current'}
        </p>
      </div>

      <InteractiveButton onClick={onPressNext} disabled={disableNext} className="mx-5 w-full max-w-[110px]">
        Next Step
      </InteractiveButton>
    </div>
  );
};
